import * as Types from '../../types/gql';

export type ExchangeRateQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ExchangeRateQuery = {
  clearing?: Types.Maybe<{
    USDRUB?: Types.Maybe<{ value: string; currency: { code: string } }>;
    RUBUSD?: Types.Maybe<{ value: string; currency: { code: string } }>;
  }>;
};
